
import {Options, Vue } from 'vue-class-component';
import SummaryActionsHistory from "@/components/summary-panel/SummaryActionsHistory.vue";
import SummaryMessage from "@/components/summary-panel/SummaryMessage.vue";
import SummaryMoHistory from "@/components/summary-panel/SummaryMoHistory.vue";
import { useRoute } from 'vue-router';
import store from "@/store";
@Options({
  components: {SummaryMoHistory, SummaryMessage, SummaryActionsHistory},
  props: ["entityState", "historiesStep"],
  created() {
    this.isLoading = true;
    store.dispatch("middleOfficeModule/getTaskHistory")
      .finally(() => {
        this.isLoading = false;
      });
  },
})

export default class SummaryHistory extends Vue {
  activeTab = 'actions';
  entityState?: any;
  historiesStep?: any;
  isLoading = true;

  isMo() {
    return this.currentRoute !== 'TaskDetail';

  }
  get currentRoute() {
    return useRoute().name;
  }
}
